import { use } from 'react';
import { useTranslation } from 'react-i18next';
import { LinkOutlined } from '@mui/icons-material';
import LinkOffOutlinedIcon from '@mui/icons-material/LinkOffOutlined';
import Button from '@mui/material/Button';
import LinkedRoomIcon from 'assets/icons/ecd-icon.svg?react';
import ViewingMode from '../../../../../../../../shared/components/viewing-mode-controller/types/viewing-mode';

import { ElectronicClientRecordLocationResultOption } from 'features/organisation/views/organisation-details/components/electronic-client-record/components/link-room-modal/domain/enums/electronic-client-record-location-result-option';
import ElectronicClientRecordProviderContext from '../../providers/contexts/electronic-client-record-context';
import useLinkedRoomItemHook from './hooks/linked-room-item-hook';
import styles from './linked-room-item.module.scss';

interface Props {
  viewingMode: ViewingMode;
}

const LinkedRoomItem = ({ viewingMode }: Props): React.JSX.Element => {
  const { t } = useTranslation('organisation', { keyPrefix: 'electronicClientRecord' });
  const { watchedSelectedRoom } = use(ElectronicClientRecordProviderContext);
  const { onUnlinkButtonClicked } = useLinkedRoomItemHook();

  return (
    <div className={styles.linkedRoomItem}>
      <div className={styles.linkedRoomItemContainer}>
        <LinkedRoomIcon
          className={`${watchedSelectedRoom?.result === ElectronicClientRecordLocationResultOption.Failed ? styles.linkedRoomIconFailed : styles.linkedRoomIcon}`}
        />
        <span className={`${styles.linkedRoomName} ${watchedSelectedRoom?.isUnlinked ? styles.unlinked : ''}`}>
          {watchedSelectedRoom?.result === ElectronicClientRecordLocationResultOption.Failed ? t('unknown') : watchedSelectedRoom?.name}
        </span>
      </div>
      {viewingMode !== 'viewing' && (
        <Button
          startIcon={watchedSelectedRoom?.isUnlinked ? <LinkOutlined /> : <LinkOffOutlinedIcon />}
          variant="text"
          onClick={onUnlinkButtonClicked}
        >
          {watchedSelectedRoom?.isUnlinked ? t('relinkRoomButtonText') : t('unlinkRoomButtonText')}
        </Button>
      )}
    </div>
  );
};

export default LinkedRoomItem;
